import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
import { createControlRoomApi } from './index';
export var createControlRoomApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createControlRoomApi(parent, fakeHttp);
    var base = parent + "/controlRoom";
    var handler = {
        whenGetAgentsTable: createFakePostResponder(fakeHttp, base + "/dashboard"),
        whengetAgentFullStats: function (agentId) { return createFakePostResponder(fakeHttp, base + "/" + agentId)({}); },
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map